import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../../store";

export const AuthProtectedRoute = () => {
  const { auth } = useContext(AuthContext);
  return !auth?.data?.token ? <Outlet /> : <Navigate to={"/"} replace />;
};
